import React from "react";
import StateCheckboxSelector from "@/components/shared/StateCheckboxSelector";
import { FunnelPicker } from "@/components/funnels/FunnelPicker";
import { Section, Field, NumIn, Choice } from "./obUi";

const CASES = [
  ["auto", "Car accidents"], ["truck", "Truck / 18-wheeler"], ["motorcycle", "Motorcycle"],
  ["rideshare", "Rideshare (Uber / Lyft)"], ["pedestrian", "Pedestrian"], ["bicycle", "Bicycle"],
  ["commercial_vehicle", "Commercial vehicle"], ["public_transportation", "Bus / public transit"], ["other", "Other accidents"],
];

export const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const LeadsSection = ({ a, set, ro, price, priceEdit }) => {
  const cases = a.case_types || [];
  const toggle = (c) => set("case_types", cases.includes(c) ? cases.filter((x) => x !== c) : [...cases, c]);
  return (
    <Section n={3} title="The leads you want" testId="ob-section-leads"
             hint="You only get leads that match these answers. Leave the limits empty for no limit.">
      <Field label="Price per lead" wide>
        {priceEdit || <div className="font-chivo font-black text-3xl" data-testid="ob-price">{money(price)}</div>}
      </Field>
      <Field label="Most leads per day"><NumIn a={a} set={set} ro={ro} k="daily_cap" testId="ob-daily-cap" placeholder="No limit" /></Field>
      <Field label="Most leads per month"><NumIn a={a} set={set} ro={ro} k="monthly_cap" testId="ob-monthly-cap" placeholder="No limit" /></Field>
      <Field label="States you take" required wide>
        <StateCheckboxSelector value={a.states || []} onChange={(v) => set("states", v)} disabled={ro} testId="ob-states" />
      </Field>
      <Field label="Case types you take" wide>
        <div className="flex flex-wrap gap-2">
          <Choice ro={ro} on={!cases.length} onClick={() => set("case_types", [])} testId="ob-case-all">All case types</Choice>
          {CASES.map(([k, label]) => (
            <Choice key={k} ro={ro} on={cases.includes(k)} onClick={() => toggle(k)} testId={`ob-case-${k}`}>{label}</Choice>
          ))}
        </div>
      </Field>
      <Field label="Pages you get leads from" required wide
             hint="Leads from these pages can come to you. We also build your own branded copy of each one.">
        <FunnelPicker value={a.funnels || []} onChange={(v) => set("funnels", v)} disabled={ro} testId="ob-funnels" />
      </Field>
    </Section>
  );
};
